package org.hs_soft.runmynesto.domain.model.home.dashboard.get_shop_statics

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class ShopStaticModel(
    @SerialName("data")
    val data: Data?,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)

@Serializable
data class Data(
    @SerialName("getShopsStatisticForDate")
    val getShopsStatisticForDate: List<ShopStatistic>?
)

@Serializable
data class ShopStatistic(
    @SerialName("branchId")
    val branchId: Int?,
    @SerialName("branchName")
    val branchName: String?,
    @SerialName("statData")
    val statData: StatData?
)

@Serializable
data class StatData(
    @SerialName("operations")
    val operations: List<Operation>?,
    @SerialName("revenueChangePct")
    val revenueChangePct: Double?,
    @SerialName("timeIntervals")
    val timeIntervals: List<TimeInterval>?,
    @SerialName("topArticlesByCount")
    val topArticlesByCount: List<TopArticle>?,
    @SerialName("topArticlesByTotal")
    val topArticlesByTotal: List<TopArticle>?,
    @SerialName("totalRevenue")
    val totalRevenue: Double?
)

@Serializable
data class Operation(
    @SerialName("caption")
    val caption: String?,
    @SerialName("count")
    val count: Double?,
    @SerialName("total")
    val total: Double?,
    @SerialName("type")
    val type: Int?
)

@Serializable
data class TimeInterval(
    @SerialName("amount")
    val amount: Double?,
    @SerialName("timeInterval")
    val timeInterval: String?
)

@Serializable
data class TopArticle(
    @SerialName("id")
    val id: Int?,
    @SerialName("name")
    val name: String?,
    @SerialName("number")
    val number: String?,
    @SerialName("value")
    val value: Double?
)